
// const moment = require('moment') // https://github.com/brockpetrie/vue-moment
// import _ from 'lodash'
// import tools from './tools'

export default {

  // 증표번호 표시
  rcptno(str) {
    if (T.isEmpty(str)) return ""
    return str.substring(0, 5) + '-' + str.substring(5, str.length)
  },
}
